var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEventCalendar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 13,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#event-calendar_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1.773 2.627c-.291 0-.527.254-.527.568v7.954c0 .314.236.569.527.569h7.379c.29 0 .527-.255.527-.569V3.196c0-.314-.236-.568-.527-.568h-7.38ZM.19 3.195c0-.941.708-1.705 1.582-1.705h7.379c.873 0 1.581.764 1.581 1.705v7.954c0 .942-.708 1.705-1.581 1.705h-7.38c-.873 0-1.58-.763-1.58-1.704V3.194Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M.191 5.468c0-.314.236-.569.527-.569h9.488c.291 0 .527.255.527.569 0 .313-.236.568-.527.568H.718c-.29 0-.527-.255-.527-.568ZM7.57.354c.292 0 .528.254.528.568v2.273c0 .314-.236.568-.527.568-.292 0-.528-.254-.528-.568V.922c0-.314.236-.568.528-.568ZM3.354.354c.291 0 .527.254.527.568v2.273c0 .314-.236.568-.527.568-.291 0-.527-.254-.527-.568V.922c0-.314.236-.568.527-.568Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.511 6.488a.186.186 0 0 1 .358 0L6.28 7.79c.025.08.097.134.179.134h1.333c.183 0 .258.24.11.35l-1.078.805a.196.196 0 0 0-.068.216l.412 1.304c.056.178-.142.326-.29.216l-1.078-.806a.184.184 0 0 0-.221 0l-1.08.806c-.147.11-.345-.038-.289-.216l.412-1.304a.196.196 0 0 0-.068-.216l-1.079-.806c-.147-.11-.071-.35.11-.35H4.92a.189.189 0 0 0 .18-.133l.411-1.303Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "event-calendar_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h11v13H0z"
})))));
SvgEventCalendar.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgEventCalendar);
export default ForwardRef;